import { Navigate, useRoutes } from 'react-router-dom'
import { docRoutes } from '../docs/routes/_config.js'
import LoginPage from '../pages/login/Login.jsx'
import ForgotPasswordPage from '../pages/login/ForgotPassword.jsx'
import RegisterAccountPage from '../pages/login/register/Register.jsx'
import IDCheck from '../pages/login/idcheck/IDCheck.jsx'
import VerifyEmail from '../pages/login/register/VerifyEmail.jsx'
import ReferenceRequest from '../pages/applications/referenceRequest/ReferenceRequest.jsx'
import PatientFeedback from '../pages/governance/feedback/forms/PatientFeedback.jsx'
import AccessRecord from '../pages/patientRecords/Sharing/PublicAccess/AccessRecord.jsx'
import JourneyTracking from '../pages/patientTransport/Tracking/JourneyTracking.jsx'
import PublicDocs from '../docs/components/PublicDocs.jsx'
import ImpersonateGate from '../pages/dev/ImpersonationGate.jsx'
import PrivacyPolicy from '../legal/PrivacyPolicy.jsx'
import TermsOfUse from '../legal/TermsOfUse.jsx'
import UpdatesHub from '../pages/dev/Updates.jsx'
import CoshhPublicView from '../pages/baseLocations/CoshhPublicView.jsx'
import WitnessStatementPublic from '../pages/governance/incidents/witness/WitnessStatementPublic.jsx'
import EventFeedbackPublic from '../pages/events/feedback/EventFeedbackPublic.jsx'
import VerifyCertificate from '../training/pages/VerifyCertificate.jsx'
import WallboardGate from '../pages/wallboard/WallboardGate.jsx'

const PublicRouter = ({ setUser, setOrgConfig, isLoggedIn, tenantInfo }) =>
  useRoutes([
    {
      path: '/docs/updates',
      element: <UpdatesHub />,
      title: 'Updates'
    },
    {
      path: '/docs/*',
      element: <PublicDocs />,
      children: docRoutes,
      title: 'Documentation'
    },
    {
      path: '/forgot-password',
      element: <ForgotPasswordPage isLoggedIn={isLoggedIn} />,
      title: 'Forgot Password'
    },
    {
      path: '/set-password',
      element: <ForgotPasswordPage withToken isLoggedIn={isLoggedIn} />,
      title: 'Forgot Password'
    },
    {
      path: '/resetpassword',
      element: <ForgotPasswordPage withToken isLoggedIn={isLoggedIn} />,
      title: 'Reset Password'
    },
    {
      path: '/register',
      element:
        isLoggedIn || tenantInfo?.subscriptionTier < 2 ? (
          <Navigate to="/" />
        ) : (
          <RegisterAccountPage />
        ),
        title: 'Register Account'
    },
    { path: '/id-check/:id', element: <IDCheck /> },
    // Certificate QR codes: also registered for signed-in users in TrainingRoutes
    { path: '/training/verify/:verificationId', element: <VerifyCertificate />, title: 'Verify a certificate' },
    { path: '/verify-email', element: <VerifyEmail /> },
    { path: '/reference-response', element: <ReferenceRequest /> },
    { path: '/patient-feedback', element: <PatientFeedback /> },
    { path: '/patient-feedback/:token', element: <PatientFeedback /> },
    { path: '/access-record', element: <AccessRecord /> },
    { path: '/track/:token', element: <JourneyTracking /> },
    { path: '/coshh/:token', element: <CoshhPublicView /> },
    { path: '/witness-statement/:token', element: <WitnessStatementPublic /> },
    { path: '/event-feedback/:token', element: <EventFeedbackPublic />, title: 'Event Feedback' },
    {
      // TV wallboard: a stored device token runs the display; otherwise a
      // site admin unlocks it (without being signed in on the device)
      path: '/wallboard',
      element:
        tenantInfo?.subscriptionTier < 2 ? <Navigate to="/" /> : <WallboardGate />,
      title: 'Wallboard',
    },
    { path: '/devopsimp', element: <ImpersonateGate /> },
    { path: '/privacy-policy', element: <PrivacyPolicy />, title: 'Privacy Policy' },
    { path: '/terms-of-use', element: <TermsOfUse />, title: 'Terms of Use' },
    {
      path: '/',
      element: <LoginPage setUser={setUser} setOrgConfig={setOrgConfig} />,
    },
    {
      path: '*',
      element: <LoginPage setUser={setUser} setOrgConfig={setOrgConfig} />,
    },
  ])

export default PublicRouter
